import {format, parseISO} from 'date-fns';
import {uk} from 'date-fns/locale';

// values reach us as ISO strings from the API, but as Date objects from local state
export const toDate = (value) => (value instanceof Date ? value : parseISO(String(value)));

// date-fns throws on an invalid date where moment used to render 'Invalid date',
// so the formatters here fall back to an empty string instead
export const formatDate = (value, pattern, options) => {
    const date = toDate(value);
    return isNaN(date.getTime()) ? '' : format(date, pattern, options);
};

export const formatDateUk = (value, pattern) => formatDate(value, pattern, {locale: uk});

// the API has always been sent moment(value).utc().format(): UTC, seconds precision
export const toUtcIso = (value) => {
    const date = toDate(value);
    return isNaN(date.getTime()) ? null : `${date.toISOString().slice(0, 19)}Z`;
};
